import { EventEmitter } from '@angular/core';
import { GenericListSelectHandlerData } from './generic-list-select-handler-data';

export class GenericListSelectDefinition {
  data: any;
  value: any;
  choices: Array<any>;
  clickHandler: EventEmitter<GenericListSelectHandlerData>;
  disabled = false;

  constructor(data: any, clickHandler: EventEmitter<GenericListSelectHandlerData>, value: any, choices: Array<any>, disabled?: boolean) {
    this.data = data;
    this.value = value;
    this.choices = choices;
    this.clickHandler = clickHandler;
    this.disabled = disabled;
  }
}
